"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/slicedToArray"));
var _react = _interopRequireWildcard(require("react"));
var Responsive = function Responsive(_ref) {
  var minWidth = _ref.minWidth,
    maxWidth = _ref.maxWidth,
    children = _ref.children;
  var _useState = (0, _react.useState)(),
    _useState2 = (0, _slicedToArray2.default)(_useState, 2),
    width = _useState2[0],
    setWidth = _useState2[1];
  (0, _react.useLayoutEffect)(function () {
    var updateSize = function updateSize() {
      setWidth(window.innerWidth);
    };
    window.addEventListener("resize", updateSize);
    updateSize();
    return function () {
      return window.removeEventListener("resize", updateSize);
    };
  });
  var render = _react.default.createElement("div", null, children);
  if (minWidth && maxWidth) {
    return minWidth < width && width < maxWidth && render;
  } else if (minWidth) {
    return minWidth < width && render;
  } else {
    return width < maxWidth && render;
  }
};
var _default = Responsive;
exports.default = _default;